import { Component } from '@angular/core';
import { GenericSelectFormControlComponent } from '@motivforce/mx-library-angular';

@Component({
  selector: 'app-custom-select-form-control',
  templateUrl: './custom-select-form-control.component.html',
  styleUrls: ['./custom-select-form-control.component.scss'],
})
export class CustomSelectFormControlComponent extends GenericSelectFormControlComponent {}
